module.exports = __webpack_public_path__ + "img/75h85_povorotnoe.32af45f6.svg";